"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nlCompanyNumberChecker = void 0;
var KVK_NUMMER_REGEX = /^\d{8}$/;
var nlCompanyNumberChecker = exports.nlCompanyNumberChecker = function nlCompanyNumberChecker(companyNumber) {
  return KVK_NUMMER_REGEX.test(companyNumber);
};